import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Label } from 'reactstrap';
import {
  checkNullValue,
  formattedDate,
  noOfDaysValueGetter,
} from '../utils/Util';
import BasicDetails from './BasicDetails';
import { handleLeaveHistoryActionColors } from '../pages/attendance/ViewAttendeesPageHelper';

interface ILeaveHistoryDetailsProps {
  leaveDetails: any;
}

const LeaveHistoryDetails: React.FunctionComponent<
  ILeaveHistoryDetailsProps
> = ({ leaveDetails }) => {
  const getProfileDetails = () => (
    <>
      {' '}
      <BasicDetails user={leaveDetails} employeeKeyShow={true} />
      <div className="mt-3 mb-2 pb-2 mx-4">
        <Label className=" mt-3 mb-1 model-comment-title  toolBar-name">
          Leave Request Details
        </Label>
        <Row>
          <Col xs={3} md={3}>
            <Label className="mb-0 model-label-name">Leave ID</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {leaveDetails?.leaveRequestId?.toString()?.padStart(4, '0') ||
                '-'}
            </Label>
          </Col>
          <Col xs={3} md={3}>
            <Label className="mb-0 model-label-name">Leave Type</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNullValue(leaveDetails?.leaveTypeName)}
            </Label>
          </Col>
        </Row>
        <Row className="mt-3 mb-3">
          <Col xs={3} md={3}>
            <Label className="mb-0 model-label-name">Leave From Date</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {formattedDate(leaveDetails?.startDate)}
            </Label>
          </Col>
          <Col xs={3} md={3}>
            <Label className="mb-0 model-label-name">Leave To Date</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {formattedDate(leaveDetails?.endDate)}
            </Label>
          </Col>
          <Col xs={3} md={3}>
            <Label className="mb-0 model-label-name">No of Days</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {noOfDaysValueGetter(leaveDetails) ?? '-'}
            </Label>
          </Col>
          <Col xs={3} md={3}>
            <Label className="mb-0 model-label-name">Reason for leave</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNullValue(leaveDetails?.reasonForLeave)}
            </Label>
          </Col>
        </Row>
        <Row>
          <Col xs={3} md={3}>
            <Label className="mb-0 model-label-name">Status</Label>
            <br />
            <Label
              className={`mb-0 model-label-value ${handleLeaveHistoryActionColors(leaveDetails)}`}
            >
              {checkNullValue(leaveDetails?.leaveStatus)}
            </Label>
          </Col>
          <Col xs={3} md={3}>
            <Label className="mb-0 model-label-name">
              {leaveDetails?.leaveStatus || 'Approved'} By
            </Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNullValue(leaveDetails?.approver)}
            </Label>
          </Col>
          <Col xs={3} md={3}>
            <Label className="mb-0 model-label-name">
              {leaveDetails?.leaveStatus || 'Approved'} On
            </Label>
            <br />
            <Label className="mb-0 model-label-value">
              {formattedDate(leaveDetails?.approvedDate)}
            </Label>
          </Col>
          <Col xs={3} md={3}>
            <Label className="mb-0 model-label-name">Leave Requested On</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {formattedDate(leaveDetails?.createdOn)}
            </Label>
          </Col>
        </Row>
      </div>
    </>
  );
  return getProfileDetails();
};

export default LeaveHistoryDetails;
